import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useSupportCopy } from "../SupportThemeProvider.js";
function HumanReplyPart({ data }) {
  const { teamLabel, teamAvatarUrl } = useSupportCopy();
  if (!(data == null ? void 0 : data.body)) return null;
  const initials = (data.adminName ?? "Support").slice(0, 1).toUpperCase();
  const avatarUrl = data.adminAvatarUrl || teamAvatarUrl || "";
  return /* @__PURE__ */ jsxs("div", { className: "tw:my-2 tw:flex tw:items-start tw:gap-2", children: [
    avatarUrl ? (
      // eslint-disable-next-line @next/next/no-img-element
      /* @__PURE__ */ jsx(
        "img",
        {
          src: avatarUrl,
          alt: "",
          className: "tw:h-7 tw:w-7 tw:rounded-full tw:object-cover tw:bg-gray-100"
        }
      )
    ) : (
      // D-33 — circle uses the soft-bg with a border ring instead of a
      // darker fill (collapsed `emerald-100` into `--bc-support-bg` + ring).
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "tw:flex tw:h-7 tw:w-7 tw:items-center tw:justify-center tw:rounded-full tw:text-xs tw:font-semibold tw:ring-1",
          style: {
            backgroundColor: "var(--bc-support-bg)",
            color: "var(--bc-support-text)",
            // ring color via inline boxShadow because Tailwind ring-[var(...)]
            // has tricky precedence with the default ring offset utilities.
            boxShadow: "inset 0 0 0 1px var(--bc-support-border)"
          },
          children: initials
        }
      )
    ),
    /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:flex-col tw:gap-0.5 tw:max-w-[80%]", children: [
      /* @__PURE__ */ jsx("div", { className: "tw:flex tw:items-center tw:gap-1.5 tw:text-xs", children: data.adminName ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "tw:font-semibold tw:text-gray-800", children: data.adminName }),
        /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "tw:text-gray-300", children: "·" }),
        /* @__PURE__ */ jsx("span", { className: "tw:font-medium", style: { color: "var(--bc-support-text)" }, children: teamLabel })
      ] }) : /* @__PURE__ */ jsx("span", { className: "tw:font-medium", style: { color: "var(--bc-support-text)" }, children: teamLabel }) }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "tw:rounded-2xl tw:rounded-tl-sm tw:px-3 tw:py-2 tw:text-sm tw:text-gray-900 tw:whitespace-pre-wrap tw:leading-relaxed",
          style: { backgroundColor: "var(--bc-support-bg)" },
          children: stripHtml(data.body)
        }
      )
    ] })
  ] });
}
function stripHtml(html) {
  return html.replace(/<br\s*\/?>(\n)?/gi, "\n").replace(/<\/(p|div)>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'").trim();
}
export {
  HumanReplyPart
};
//# sourceMappingURL=HumanReplyPart.js.map
